import React from "react";

const LandscapeOrientation = () => (
  <style type="text/css">
    {"@media print{@page {size: landscape}}"}
  </style>
);

export default LandscapeOrientation;
